// src/components/Item/StockHistory.jsx

import React from "react";
import { useGetStockHistoryQuery } from "../../redux/slices/usersApiSlice";
import styles from "./StockReports.module.css";

const StockHistory = ({ userId, itemId }) => {
  const { data: logs, isLoading, isError } = useGetStockHistoryQuery(
    { userId, itemId },
    { refetchOnMountOrArgChange: true }
  );

  if (isLoading) return <p>Yükleniyor...</p>;
  if (isError) return <p>Geçmiş yüklenemedi.</p>;
  if (!logs || logs.length === 0) {
    return (
      <p className={styles.muted}>
        Bu ürün için henüz kayıtlı değişiklik yok. (Geçmiş, bu özellik eklendikten
        sonra yapılan değişiklikleri gösterir.)
      </p>
    );
  }

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Tarih</th>
            <th>Eski</th>
            <th>Yeni</th>
            <th>Fark</th>
            <th>Değiştiren</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => {
            const diff = log.newCount - (log.oldCount ?? 0);
            return (
              <tr key={log._id}>
                <td>{new Date(log.createdAt).toLocaleString("tr-TR")}</td>
                <td>{log.oldCount ?? "-"}</td>
                <td>{log.newCount}</td>
                <td className={diff < 0 ? styles.negative : styles.positive}>
                  {diff > 0 ? `+${diff}` : diff}
                </td>
                <td>
                  {log.changedBy
                    ? log.changedBy.isSuperAdmin
                      ? "Admin"
                      : log.changedBy.name
                    : "-"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StockHistory;
